import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useConfirm } from 'material-ui-confirm';
import { trpc } from '../../api/trpc';

export const useRemoveDhcpHost = () => {
  const confirm = useConfirm();
  const utils = trpc.useContext();

  const { mutateAsync: removeHost } = trpc.removeDhcpHost.useMutation({
    onSuccess() {
      utils.network.get.invalidate();
    },
  });

  const onDhcpHostRemove = (index: number) => {
    confirm({
      title: (
        <FormattedMessage
          id="dhcp_hosts.remove.confirm.title"
          defaultMessage="Opravdu chcete odfixovat adresu DHCP hosta?"
        />
      ),
      confirmationText: (
        <FormattedMessage
          id="dhcp_hosts.remove.confirm"
          defaultMessage="Smazat"
        />
      ),
      cancellationText: (
        <FormattedMessage
          id="dhcp_hosts.remove.cancel"
          defaultMessage="Zrušit"
        />
      ),
    })
      .then(() => {
        return removeHost({ index });
      })
      .catch(() => {
        // noop
      });
  };

  return { onDhcpHostRemove };
};

export const useMakeDhcpLeaseStatic = () => {
  const confirm = useConfirm();
  const utils = trpc.useContext();

  const { mutateAsync: addDhcpHost } = trpc.addDhcpHost.useMutation({
    onSuccess() {
      utils.network.get.invalidate();
    },
  });

  const onMakeDhcpLeaseStatic = ({
    address,
    mac,
    name,
  }: {
    address: string;
    mac: string;
    name?: string;
  }) => {
    confirm({
      title: (
        <FormattedMessage
          id="dhcp_leases.make_static.confirm.title"
          defaultMessage="Opravdu chcete zafixovat adresu DHCP hosta?"
        />
      ),
      confirmationText: (
        <FormattedMessage
          id="dhcp_leases.make_static.confirm"
          defaultMessage="Přidat"
        />
      ),
      cancellationText: (
        <FormattedMessage
          id="dhcp_leases.make_static.cancel"
          defaultMessage="Zrušit"
        />
      ),
    })
      .then(() => {
        return addDhcpHost({ address, mac, name });
      })
      .catch(() => {
        // noop
      });
  };

  return { onMakeDhcpLeaseStatic };
};
